export const MAIN_CONTENT = 50
export const HEADER = 101
export const MODAL_BACKDROP = 200
export const MODAL_CONTENT = MODAL_BACKDROP + 1
export const ALERT = MODAL_CONTENT + 1
